import { useEffect, useMemo } from 'react'
import { motion, useMotionValue, useTransform } from 'framer-motion'
import { animate } from 'framer-motion'

type Formatter = (n: number) => string

interface Props {
  value: number
  format?: Formatter
  
  className?: string
  duration?: number
}

const DEFAULT_FORMAT: Formatter = (n) => Math.round(n).toString()

export function AnimatedNumber({
  value,
  format = DEFAULT_FORMAT,
  className,
  duration = 0.9,
}: Props) {
  const motionValue = useMotionValue(value)
  const display = useTransform(motionValue, (latest) => format(latest))

  useEffect(() => {
    const controls = animate(motionValue, value, {
      duration,
      ease: [0.16, 1, 0.3, 1],
    })
    return controls.stop
  }, [value, motionValue, duration])

  const fallback = useMemo(() => format(value), [value, format])

  return (
    <span className={className}>
      <motion.span aria-hidden="true">{display}</motion.span>
      <span className="sr-only">{fallback}</span>
    </span>
  )
}
